import AccountActivation from 'pages/AccountActivation';
import Otp from 'pages/ChangePassword/Otp';
import SetPassword from 'pages/ChangePassword/SetPassword';
import { FingerRegister } from 'pages/fingerRegister';
import ForceChangePassword from 'pages/ForceChangePassword';
import ForgetChangePassword from 'pages/ForgetPassword/forgetChangePassword';
import ForgetRequest from 'pages/ForgetPassword/forgetRequest';
import ForgetValidation from 'pages/ForgetPassword/forgetValidation';
import Login from 'pages/Login';
import { Logout } from 'pages/logout';
import SetTwoFactor from 'pages/SetTwoStep';
import TwoStepPage from 'pages/TwoStepLogin';
import { useRoutes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

export const Routes = () => {
  let routes = useRoutes([
    { element: <Navigate to="/login" />, index: true },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: 'login/twoFactor',
      element: <TwoStepPage />,
    },
    {
      path: 'forget-password/request',
      element: <ForgetRequest />,
    },
    {
      path: 'forget-password/validation',
      element: <ForgetValidation />,
    },
    {
      path: 'forget-password/change-password',
      element: <ForgetChangePassword />,
    },
    {
      path: '/logout',
      element: <Logout />,
    },
    {
      path: 'two-factor',
      element: <SetTwoFactor />,
    },
    {
      path: 'change-password',
      element: <SetPassword />,
    },
    {
      path: 'change-password/otp',
      element: <Otp />,
    },
    {
      path: 'force-change-password',
      element: <ForceChangePassword />,
    },
    {
      path: 'account-activation',
      element: <AccountActivation />,
    },
    {
      path: 'finger-register',
      element: <FingerRegister />,
    },
  ]);

  return routes;
};
